import { render, staticRenderFns } from "./FundCitation.vue?vue&type=template&id=01fb1b65&scoped=true"
import script from "./FundCitation.vue?vue&type=script&lang=js"
export * from "./FundCitation.vue?vue&type=script&lang=js"
import style0 from "./FundCitation.vue?vue&type=style&index=0&id=01fb1b65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fb1b65",
  null
  
)

export default component.exports